import { default as React, useContext } from 'react';
import { __RouterContext, RouteComponentProps } from 'react-router';

type RouterContext<T> = React.Context<RouteComponentProps<T>>;

export function useRouter<P extends { [K in keyof P]?: string } = {}>() {
  return useContext((__RouterContext as any) as RouterContext<P>);
}



// WEBPACK FOOTER //
// ./src/hooks/useRouter.ts